// Cache to prevent flickering from creating new blob URLs
const iconCache = new Map();

export default function ({ color }) {
  color = color || '#00a98c';
  
  // Return cached version if it exists
  if (iconCache.has(color)) {
    return iconCache.get(color);
  }
  
  let svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="m21 21-4.35-4.35" stroke="${color}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="20" cy="20" r="1.5" fill="${color}"/>
        </svg>
    `;
  let blob = new Blob([svg], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(blob);
  
  // Cache the result
  iconCache.set(color, url);
  
  return url;
}
